import * as yup from "yup";
import { FormInputMeta } from "@Modules/core/types/FormMetaType";
import { getValidationSchema } from "@Shared/utils/validationSchema";

export interface IMemoDataTableRowFormMeta {
    user: FormInputMeta;
    memo: FormInputMeta;
    activatedAt: FormInputMeta;
    purgedAt: FormInputMeta;
    expiredAt: FormInputMeta;

    schema: any;
}

const memoDataTableRowFormMeta = {} as IMemoDataTableRowFormMeta;

memoDataTableRowFormMeta.user = {
    name: "user",
    type: "text",
    label: "Utilisateur",
    placeholder: "",
    validation: yup.string().required("Champ obligatoire !")
};

memoDataTableRowFormMeta.memo = {
    name: "memo",
    type: "textarea",
    label: "Memo",
    placeholder: "",
    validation: yup.string().required("Champ obligatoire !")
};

memoDataTableRowFormMeta.activatedAt = {
    name: "activatedAt",
    type: "datetime-local",
    label: "Activé le",
    placeholder: "",
    validation: yup.string()
};

memoDataTableRowFormMeta.purgedAt = {
    name: "purgedAt",
    type: "datetime-local",
    label: "Purgé le",
    placeholder: "",
    validation: yup.string()
};

memoDataTableRowFormMeta.expiredAt = {
    name: "expiredAt",
    type: "datetime-local",
    label: "Expiré le",
    placeholder: "",
    validation: yup.string()
};


memoDataTableRowFormMeta.schema = yup.object().shape(getValidationSchema(memoDataTableRowFormMeta));

export default memoDataTableRowFormMeta;